module.exports = __webpack_public_path__ + "img/Ute_Back.bbb8e1e5.svg";